import LTR from "@brand-icons/ploom/basket-fill/basket-fill-ltr.svg";

import { iconFactory } from "../iconFactory";

export const BasketFillIcon = iconFactory("BasketFillIcon", LTR);
